export const PROJECT_USER_ROLES = {
  OWNER: 1,
  ADMIN: 2,
  MANAGER: 3,
  CUSTODIAN: 4
};
export const PROJECT_USER_ROLE_NAMES = {
  OWNER: { name: "مالک", type: PROJECT_USER_ROLES.OWNER },
  ADMIN: { name: "ادمین", type: PROJECT_USER_ROLES.ADMIN },
  MANAGER: { name: "مدیر", type: PROJECT_USER_ROLES.MANAGER },
  CUSTODIAN: { name: "تنخواه‌دار", type: PROJECT_USER_ROLES.CUSTODIAN }
};
export const PROJECT_USER_ROLE_COLORS = {
  OWNER: "owner",
  ADMIN: "admin",
  MANAGER: "manager",
  CUSTODIAN: "custodian"
};
export const PROJECT_USER_STATE = {
  ACTIVE: 1,
  PENDING: 2,
  INACTIVE: 40
};

export const PROJECT_USER_STATE_NAMES = {
  1: "فعال",
  2: "در انتظار پاسخ",
  40: "غیرفعال"
};

export const PROJECT_USER_STATE_COLORS = {
  1: "success",
  2: "pending",
  40: "disable"
};
